// @ts-nocheck

import React, { useState } from "react";
import { notification } from "antd";
import "../Login.css";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Logo from "../../../theme/images/logo_oseo_valais_retina.png";
import { http } from "../../../engine/api/http";
import CustomForm from "../../../shared/components/CustomForm";
import back from "../../../theme/images/back.jpeg";
import { resetPassword } from "../../../engine/api/apiRequest";
import { throttle } from "lodash";
import { HiOutlineMail } from "react-icons/hi";

export const PasswordLost = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const throttledSubmit = throttle(async data => {
    setLoading(true);
    console.log("Submitted", new Date());

    console.log("trigger");

    let send = await resetPassword(data);
    // Mock an API call

    notification.success({
      message: `Demande de mot de passe`,
      description:
        "Si votre adresse e-mail figure dans notre système, vous recevrez un e-mail contenant les instructions.",
    });
    await new Promise(resolve => setTimeout(resolve, 1000));

    setLoading(false);
  }, 2000); // Limit to one submission every 2 seconds

  const inputs = [
    {
      parentLabel: "Renseigner votre email",
      children: [
        {
          label: "Email",
          placeholder: "Email",
          name: "email",
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          capitalize: false,
          type: "input",
          required: true,
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: "Envoyer la demande",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "left",
        },
      ],
    },
  ];

  return (
    <div className={"login-back"} style={{ backgroundImage: `url(${back})` }}>
      <Helmet>
        <title>OSEO - Mot de passe perdu</title>
      </Helmet>
      <div className={"login-container"}>
        <div className={"login-box"}>
          <Link className="login-form-forgot" to="/auth/login">
            <img src={Logo} className={"login-logo"} alt={"logo-oseo"} />
          </Link>
          <CustomForm
            dataSource={inputs}
            labelCol={24}
            wrapperCol={24}
            loading={loading}
            handleSubmit={throttledSubmit}
          />
        </div>
      </div>
    </div>
  );
};
